import type { ApiClient } from '../../api/client';
import type { OrganizationNode, OrganizationPort } from '../../features/organization/public';
import type { SupervisoryOrganization } from '../../api/types';

function mapOrganization(organization: SupervisoryOrganization): OrganizationNode {
  return {
    id: organization.id,
    name: organization.descriptor || organization.organizationCode || '이름 미등록',
    subtitle: organization.organizationCode || '감독 조직',
    manager: organization.manager?.descriptor || '미지정',
    managerId: organization.manager?.id ?? null,
    count: organization.memberCount ?? 0,
    location: organization.location?.descriptor || '미지정',
    parentId: organization.parent?.id,
  };
}

export function createOrganizationHttpAdapter(client: ApiClient): OrganizationPort {
  return {
    async listOrganizations(asOf) {
      return (await client.listAllSupervisoryOrganizations(asOf)).data.map(mapOrganization);
    },
    async listWorkers() {
      return (await client.listAllWorkers()).data.map((worker) => ({
        id: worker.id,
        name: worker.descriptor?.trim() || '이름 미등록',
        workerNumber: worker.workerId || '사번 미등록',
      }));
    },
    async listMembers(organizationId, asOf) {
      const result = await client.listSupervisoryOrganizationMemberPreview(organizationId, asOf);
      return {
        total: result.total,
        members: result.data.map(worker => ({
          id: worker.id,
          name: worker.descriptor?.trim() || '이름 미등록',
          profilePhotoUrl: worker.person?.profilePhotoUrl,
        })),
      };
    },
    async listChanges() {
      return (await client.listAllOrganizationChanges()).data;
    },
    createOrganization(input, idempotencyKey) {
      return client.createSupervisoryOrganization(input, idempotencyKey);
    },
    createChange(organizationId, input, idempotencyKey) {
      return client.createOrganizationChange(organizationId, input, idempotencyKey);
    },
    submitChange(changeId, idempotencyKey) {
      return client.submitOrganizationChange(changeId, idempotencyKey);
    },
    cancelEvent(eventId, comment, idempotencyKey) {
      return client.cancelBusinessProcessEvent(eventId, comment, idempotencyKey);
    },
  };
}
